import { render, staticRenderFns } from "./v-speak-text.vue?vue&type=template&id=37a9962a&scoped=true&"
import script from "./v-speak-text.vue?vue&type=script&lang=js&"
export * from "./v-speak-text.vue?vue&type=script&lang=js&"
import style0 from "./v-speak-text.vue?vue&type=style&index=0&id=37a9962a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a9962a",
  null
  
)

export default component.exports